export const invitationUrlRegExp = /\/#\/i\/(?:.*)+/u
export const slaDurationRegExp = /^[1-9][0-9]*[mhd]$/u
export const slaDurationNumericRegExp = /^[1-9][0-9]*$/u

// Allow 0:00-24:00 (TODO: regex allows consecutive numbers after minutes: eg. 23:59999 is accepted :(
export const timeValidation = /^(?:2[0-3]|1[0-9]|[0-9]):(?:0[0-9]|[1-5][0-9])|24:00/iu

// eslint-disable-next-line require-unicode-regexp
export const checkHex = new RegExp(/^#[0-9A-F]{6}$/i)
